/*
SAVE-TOAST
Display item to save
*/
import { FadeIn } from "@/utils/animations.utils"
import Button from "./button"
import { faSave, faTimes, faTrash, faUndo } from "@fortawesome/free-solid-svg-icons"
import Space from "./space"
import { StatusType } from "@/core/factory/types"
import { ReactNode, useEffect, useState } from "react"
import Tooltip from "./tooltip"

interface Props {
  selectedCount?: number
  isSaveActive?: boolean
  onCancel?: Function | null
  onClose?: Function | null
  onDelete?: Function | null
  onSave?: Function | null
  onSaveTooltip?: string
  status?: StatusType
  children?: ReactNode
}

export default function SaveToast({
  selectedCount,
  isSaveActive,
  onCancel,
  onClose,
  onDelete,
  onSave,
  onSaveTooltip,
  status,
  children
}: Props) {
  const [showSave, setShowSave] = useState(false)

  //Trigger fadeOut animation
  useEffect(() => {
    if (onSave) {
      setShowSave(true)
    } else {
      setTimeout(() => {
        setShowSave(false)
      }, 250)
    }
  }, [onSave])

  return (
    <FadeIn
      style={{ padding: 16 }}
      className="fixed right-0 bottom-0 bg-white z-[99] w-full flex shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1),0_-2px_4px_-2px_rgba(0,0,0,0.1)]">
      <div className="w-[32px]"></div>

      {onClose && (
        <Button
          onClick={isSaveActive ? undefined : onClose}
          className={isSaveActive ? "light" : undefined}
          icon={faTimes}
          isWithBorder>
          Fermer
        </Button>
      )}

      <Space />

      {selectedCount && (
        <div className="m-auto text-sm mr-[12px] font-bold">
          {selectedCount === 1 && <span>1 ligne sélectionnée</span>}
          {selectedCount > 1 && <span>{selectedCount} lignes sélectionnées</span>}
        </div>
      )}

      {onDelete && (
        <Button onClick={onDelete} icon={faTrash} isWithBorder>
          Supprimer
        </Button>
      )}

      {onCancel && (
        <Button
          onClick={isSaveActive ? onCancel : undefined}
          icon={faUndo}
          isWithBorder
          className={isSaveActive ? undefined : "light"}>
          Annuler
        </Button>
      )}

      {children}

      {showSave && (
        <Tooltip text={onSaveTooltip}>
          <Button
            width={164}
            isLoading={status === "STATUS_SAVING" ? true : false}
            onClick={onSave && isSaveActive ? onSave : undefined}
            icon={faSave}
            className={isSaveActive ? "primary" : "light"}
            isWithBorder>
            Sauvegarder
          </Button>
        </Tooltip>
      )}
    </FadeIn>
  )
}
